module.exports = __webpack_public_path__ + "img/relevantItem.e7e4da82.png";